<template>
    <v-image-file-field
        :value="file.id"
        :label="file.file_name"
        :name="'file-' + file.id"
        @input="handleInput"
        upload-only
    />
</template>

<script>
    export default {
        props: ['file'],
        methods: {
            handleInput(file)
            {
                this.$emit('complete')
            }
        }
    }
</script>